export const variantPropMap = {
  v1: {
    variant: 'v1',
    className: 'app-bar',
    iconButtonVariant: 'outlined'
  },
  v2: {
    variant: 'v2',
    className: 'app-bar--v2',
    iconButtonVariant: 'standardV2'
  }
};
